import { Helmet } from 'react-helmet-async';
const logo = "https://s3.ap-northeast-2.amazonaws.com/img.bear-u.com/assets/logo.png";

const Seo = ((props) => {
  const {title, description} = props;
  const keywords = "비즈니스 베어유, bearu, biz-bear-u, 온라인 클래스, 인터넷 강의, 인강, 커리어, PPT";
  return (
    <>
      <Helmet>
        <meta name="type" content="website" />
        <meta name="title" content={title} />
        <meta name="description" content={description} />
        <meta name="keywords" content={keywords} />

        <meta property="og:type" content='website' />
        <meta property="og:local" content="ko_KR" />
        <meta property="og:image" content={logo}/>
        <meta property="og:url" content="https://biz.bear-u.com/" />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta property="og:keywords" content={keywords} />

        <link rel="canonical" href="/overview/all"/>
        <meta name="twitter:card" content="summary_large_image"/>
        <meta name="twitter:title" content={title}/>
        <meta name="twitter:description" content={description} />
        <meta name="twitter:image" content={logo}/>

        <meta itemProp="name" content={title} />
        <meta itemProp="description" content={description} />
        <meta itemProp="image" content={logo}/>
        <meta name="referrer" content="origin"/>

        <title>{title}</title>
      </Helmet>
    </>
  );
});

export default Seo;